import Collapse from "../../common/Collapse";
import { useTranslation } from "react-i18next";
import TemplateItem from "../templates/TemplateItem";
import { renderTemplateStylingSettings } from "../templates";

export default function StyleBrandingCollapse({
  videoTemplates,
  selectedVideoTemplate,
  setSelectedVideoTemplate,
  styleSettings,
  mergeStyleSettings,
  handleStyleChange,
}) {
  const { t } = useTranslation();
  return (
    <Collapse
      title={
        <div className="font-semibold text-gray-800 text-2xl">
          {t("video style & branding")}
        </div>
      }
      defaultOpen
    >
      <div className="mb-4">
        <div className="text-xl font-semibold text-gray-800 mr-4 w-min-content">
          {t("video templates")}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {videoTemplates.map((template) => (
            <TemplateItem
              key={template.name}
              name={template.name}
              videoUrl={template.videoUrl}
              selected={selectedVideoTemplate?.name === template.name}
              onClick={() => {
                setSelectedVideoTemplate(template);
                // Merge template default settings if available
                if (template.defaultStyleSettings) {
                  mergeStyleSettings(template.defaultStyleSettings);
                }
              }}
            />
          ))}
        </div>
      </div>

      {selectedVideoTemplate &&
        renderTemplateStylingSettings(
          selectedVideoTemplate.name,
          styleSettings,
          handleStyleChange
        )}
    </Collapse>
  );
}
